<script >
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'messageCreateDialog',
})
</script>
<template>
  <div data-html2canvas-ignore>
    <el-dialog
      v-model="open"
      top="2vh"
      width="1200"
      title="创建消息"
      destroy-on-close
      center
      :before-close="beforeClose"
      @open="openDialog"
      @opened="opened"
    >
      <MessageContent
        class="message-content"
        ref="messageContentRef"
        :originData="originData"
        :dialog="true"
      />
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="send">发送</el-button>
          <el-button type="success" @click="save">保存草稿</el-button>
          <el-button @click="open = false">取消</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup name="messageCreateDialog">
import { uploadFileApi } from "@/api/messageSystem";
import { ElMessage } from "element-plus";
import MessageContent from "./messageContent.vue";
import { addOperationNotice } from "@/api/messageSystem";
import html2canvas from "html2canvas";
const messageContentRef = ref();
const emits = defineEmits(["refresh"]);

const route = useRoute();

const screenShot = ref("");
const originData = ref({});
watch(
  ()=>route,
  (val) => {
    originData.value = {
      pageUrl: window.location.origin + route.fullPath,
      menuId: route.meta.title,
    };
  }
);
const openDialog = () => {
  messageContentRef.value.loadData();
};
const opened = ()=>{
  // handleScreenshot();
}
//弹框显示
const open = defineModel("visible", {
  type: Boolean,
  require: true,
  dafault: false,
});
async function send() {
  const data = await messageContentRef.value.commit(1);
  console.log("send", data);
  await addOperationNotice(data);
  ElMessage.success("发送成功");
  open.value = false;
}
async function save() {
  const data = await messageContentRef.value.commit(0);
  console.log("save", data);
  await addOperationNotice(data);
  ElMessage.success("保存成功");
  open.value = false;
}
function beforeClose(done) {
  messageContentRef.value.resetForm();
  originData.value = {}
  done();
}
const handleScreenshot = async () => {
  try {
    const app = document.getElementById("app");
    const canvas = await html2canvas(app, {
      useCORS: true,
      width:document.body.clientWidth,
      height: document.body.clientHeight,
    });
    // 转Blob
    const blob = await new Promise((resolve) =>
      canvas.toBlob((blob) => resolve(blob), "image/png")
    );
    const formData = new FormData();
    formData.append("file", blob, `${Date.now()}_screenshot.png`);
    const { data } = await uploadFileApi(formData);
    screenShot.value = data.url;
    console.log(screenShot.value)
  } catch (error) {
    console.log(error);
    ElMessage.error("截屏失败");
  }
};
</script>

<style lang="scss" scoped>
.message-content {
  max-height: calc(80vh - 120px);
  overflow-y: auto;
}
</style>
